import { call, select } from "redux-saga/effects";

import { Route } from "@mapmycustomers/shared/types/entity";
import Organization from "@mapmycustomers/shared/types/Organization";

import AverageStopsPerRouteCardData from "@app/scene/dashboard/store/cards/averageStopsPerRoute/AverageStopsPerRouteCardData";
import { getFilters } from "@app/scene/dashboard/store/cards/averageStopsPerRoute/sagas";
import { callApi } from "@app/store/api/callApi";
import { getOrganizationId } from "@app/store/iam";
import AverageStopsPerRouteCardConfiguration from "@app/types/dashboard/cards/averageStopsPerRoute/AverageStopsPerRouteCardConfiguration";
import Scope from "@app/types/dashboard/Scope";
import type AggregatedListResponse from "@app/types/viewModel/AggregatedListResponse";

export interface AggregationResult {
  sum_items?: { value: number };
}

export function* fetchAverageStopsPerRouteCardDataHelper(params: {
  callback: (data: AverageStopsPerRouteCardData) => void;
  configuration: AverageStopsPerRouteCardConfiguration;
  scope?: Scope;
}) {
  const { callback, scope } = params;
  const orgId: Organization["id"] = yield select(getOrganizationId);

  const $filters = getFilters(scope);

  const result: AverageStopsPerRouteCardData = { count: 0 };

  // Routes v2 unified company/people routes into a single "smart-routes" endpoint,
  // so we no longer fetch per entity type and sum.
  const response: AggregatedListResponse<Route, AggregationResult> = yield callApi(
    "fetchUnifiedRoutesAggregated",
    orgId,
    {
      $aggs: { sum: ["items"] },
      $filters,
      $limit: 0,
    }
  );

  const totalItemsInRoutes = response.aggregations.sum_items?.value ?? 0;
  // `total` is the count matching the card's $filters (its scope); `accessible` is the
  // unfiltered ceiling of routes the viewer can see. sum_items is filter-scoped, so divide
  // by the filter-scoped route count to keep numerator and denominator on the same scope.
  const totalRoutes = response.total;

  result.count = totalRoutes !== 0 ? totalItemsInRoutes / totalRoutes : 0;

  yield call(callback, result);
}
